import * as React from 'react';
import { Modal, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import * as actionCreator from '../../actions/actions';
import { Dispatch } from 'redux';
import { Log } from "../../class/Log";
import Select from 'react-select';
import { MyLookup } from '../../class/Enums';
import { UserAircraft } from '../../class/UserAircraft';
import '../css/ModernPopups.css';

interface State {
    userAircraftId: any;
    aircraftModel: any;
    aircraftRegistration: any;
}

interface Props {
    popupTitle: string;
    show: boolean;
    token: any;
    userAircraft: UserAircraft;
    aircraftModelList: any;
    userAircraftList: Array<UserAircraft>;
    hide(): void;
    saveUserAircraft(token: any, p: UserAircraft): void;
    updateUserAircraft(token: any, p: UserAircraft): void;
    getLookupList(): any;
}

class UserAircraftPopup extends React.Component<Props, State>{
    private socket: any;

    constructor(props: any) {
        super(props)
        this.state = {
            userAircraftId: 0,
            aircraftModel: "",
            aircraftRegistration: "",
        };
    }

    componentDidMount() {
       
        this.props.getLookupList();
    }

    componentDidUpdate(nextProps: any) {
        let aircraftLabel = this.props.userAircraft != undefined ? this.props.userAircraft.aircraftModel?.aircraftModelName : null;
        let aircraftValue = this.props.userAircraft != undefined ? this.props.userAircraft.aircraftModel?.aircraftModelId : null;

        //Edit selected logbook
        if (this.props !== nextProps) {
            this.setState({
                userAircraftId: this.props.userAircraft.userAircraftId,
                aircraftModel: { label: aircraftLabel, value: aircraftValue },
                aircraftRegistration: this.props.userAircraft.aircraftRegistration,
            })
        }
    }

    handleChange = (e: any) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        this.setState({
            [e.target.id]: value
        } as any);
    }

    handleAircraftChange = (aircraftModel: any) => {
        this.setState({ aircraftModel: aircraftModel});
    };


    handleSaveLog = (e: any) => {
        e.preventDefault();
        var myAircraft: UserAircraft = ({
            userAircraftId: this.state.userAircraftId,
            aircraftModelId: this.state.aircraftModel.value,
            aircraftRegistration: this.state.aircraftRegistration,
            isAircraftFavorit: false
        });

        if (myAircraft.userAircraftId != undefined) {
            this.props.updateUserAircraft(this.props.token, myAircraft);
        }
        else {
            this.props.saveUserAircraft(this.props.token, myAircraft);
        }

       
        this.props.hide();
    }



    render() {

        // Extract the IDs of aircraft in the user's list
        // const userAircraftIds = this.props.userAircraftList.map(item => item.aircraftModel?.aircraftModelId);
        // const filteredAircraftList = this.props.aircraftModelList?.filter(
        //     (model: { value: number | undefined; }) => !userAircraftIds.includes(model.value)
        // );

        return (
            <Modal 
                show={this.props.show} 
                onHide={() => this.props.hide()}
                className="modern-modal"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-plane"></i>
                        {this.props.popupTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form id="newEntryForm" onSubmit={this.handleSaveLog}>
                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-plane-departure"></i>
                                Aircraft Model
                            </label>
                            <div className="modern-select">
                                <Select 
                                    id="aircraftModel" 
                                    value={this.state.aircraftModel} 
                                    onChange={this.handleAircraftChange} 
                                    options={this.props.aircraftModelList} 
                                    placeholder="Select aircraft model"
                                    isClearable
                                />
                            </div>
                        </div>
                        
                        <div className="modern-form-group">
                            <label className="modern-form-label">
                                <i className="fas fa-id-card"></i>
                                Aircraft Registration
                            </label>
                            <input 
                                id="aircraftRegistration" 
                                value={this.state.aircraftRegistration || ''} 
                                type="text" 
                                className="modern-form-control" 
                                placeholder="Enter aircraft registration (e.g., N123AB, D-EABC)" 
                                required 
                                onChange={this.handleChange}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.hide()}>
                        <i className="fas fa-times me-2"></i>
                        Cancel
                    </Button>
                    <Button variant="success" type="submit" form="newEntryForm">
                        <i className="fas fa-save me-2"></i>
                        Save Aircraft
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

//map the props of this class to the root redux state
const mapStateToProps = (state: any) => {
    return {
        userId: state.userId,
        aircraftModelList: state.lookupList[MyLookup.AircraftList],
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        saveUserAircraft: (token: any, userAircraft: UserAircraft) => dispatch<any>(actionCreator.default.userAircraft.saveUserAircraft(token, userAircraft)),
        updateUserAircraft: (token: any, userAircraft: UserAircraft) => dispatch<any>(actionCreator.default.userAircraft.updateUserAircraft(token, userAircraft)),
        getLookupList: () => dispatch<any>(actionCreator.default.lookup.getLookupList()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAircraftPopup);